export const merchantInfoDataSaga = (state) => state.merchantsInfoReducer.merchantsInfoRow;
export const merchantInfoDataErrorSaga = (state) => state.merchantsInfoReducer.merchantsInfoRowError;
export const selectedAggregators = (state) => state.merchantsInfoReducer.aggregators;
export const selectedBrandNames = (state) => state.merchantsInfoReducer.activebrandnames;
export const selectedBrandId= (state) => state.merchantsInfoReducer.activebrandid;
export const selectLocationsList = (state) => state.merchantsInfoReducer.activelocationslist;
export const selectLocations = (state) => state.merchantsInfoReducer.activelocationscount;
export const selectBusinessName = (state) => state.merchantsInfoReducer.activebusinessname;
